enum ProductTypes {
  EMAIL = "EMAIL",
  CINEMA = "CINEMA",
  SINGLE_PRODUCT = "SINGLE_PRODUCT",
  SINGLE_PRODUCT_QUANTITY = "SINGLE_PRODUCT_QUANTITY",
  MULTIPLE_PRODUCTS = "MULTIPLE_PRODUCTS",
  OPEN_VALUE_PRODUCT = "OPEN_VALUE_PRODUCT",
  PAYMENT = "PAYMENT",
  BIRTHDAY_BOX = "BIRTHDAY_BOX"
}

export default ProductTypes
